import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "../Solution/SubscribeForm.css";

const SubscribeForm = () => {
  const { state } = useLocation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    pincode: "",
    address: "",
    plan: state?.title || "",
    price: state?.price || "",
  });

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // success | error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePayNow = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.mobile || !formData.email) {
      setMessageType("error");
      setMessage("Please fill all required fields");
      return;
    }

    const paymentURL = `https://api.payinfintech.com/payinfintech.php?amount=${encodeURIComponent(
      formData.price
    )}&name=${encodeURIComponent(formData.name)}&mobile=${encodeURIComponent(
      formData.mobile
    )}&email=${encodeURIComponent(formData.email)}`;

    // ✅ Payment new tab me open
    window.open(paymentURL, "_blank");

    // ✅ SAME PAGE message
    setMessageType("success");
    setMessage(
      "Payment window opened. If payment is successful, it will be processed shortly."
    );
  };

  return (
    <div className="subscribe-wrapper">
      <div className="subscribe-form">
        <h2>Complete Your Subscription</h2>

        <p className="plan-name">
          Selected Plan: <span>{formData.plan}</span>
        </p>

        {/* ✅ Message Box */}
        {message && (
          <div className={`alert ${messageType}`}>
            {message}
          </div>
        )}

        <form onSubmit={handlePayNow}>
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Mobile Number</label>
            <input
              type="tel"
              name="mobile"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Pincode</label>
            <input
              type="text"
              name="pincode"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Address</label>
            <textarea
              name="address"
              rows="3"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Amount</label>
            <input
              type="text"
              value={formData.price}
              readOnly
              className="amount-input"
            />
          </div>

          <div className="d-flex justify-content-end">
            <button type="submit" className="pay-btn">
              Pay Now
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubscribeForm;
